import { KeyReservesMetricsComponent } from '@/admins/SmartReports/components/Components/Tables/KeyReservesMetricsTable';
import { AssetNameComponent } from '@/admins/SmartReports/components/Components/TextFields/AssetName';
import { TextAreaWithHeaderComponent } from '@/admins/SmartReports/components/Components/TextFields/TextAreaWithHeader';
import {
  CapexByYearStackedChartComponent,
  CashflowByYearStackedChartComponent,
  GasProductionByMonthStackedChartComponent,
  NpvByCountryComponent,
  NpvByProductionChartComponent,
  OilProductionByMonthStackedChartComponent,
  ProductionByMonthStackedByTypeChartComponent,
  ProductionByMonthStackedByTypeTotalChartComponent,
  ProductionByMonthStackedChartComponent,
  RemainingProjectRevenueDistributionComponent,
  RemainingReservesBaseCaseDonutChartComponent,
  ReservesByCountryStackedByDevelopmentStatus,
  ReservesByCountryStackedByType,
  WellCountByYearStackedByClassification,
} from './Charts';
import { AssetViewPictureComponent, CountryViewPictureComponent } from './Images';
import {
  AssetCurrentParticipationTableComponent,
  AssetFeaturesTableComponent,
  AssetReservesTableComponent,
  AssetTimeTableComponent,
  FinancialConsiderationsTableComponent,
  HistoricalParticipationTableComponent,
  ReservoirCharacteristicsTableComponent,
  WellStatisticsTableComponent,
} from './Tables';
import { ProductionTableComponent } from './Tables/ProductionTable';
import { CompanyNameComponent } from './TextFields/CompanyName';
import { TextAreaComponent } from './TextFields/TextArea';

const CommonReportComponents = [TextAreaComponent, TextAreaWithHeaderComponent];

const CorporateReportComponents = [
  RemainingReservesBaseCaseDonutChartComponent,
  CompanyNameComponent,
  ProductionTableComponent,
  NpvByCountryComponent,
  NpvByProductionChartComponent,
  GasProductionByMonthStackedChartComponent,
  OilProductionByMonthStackedChartComponent,
  CashflowByYearStackedChartComponent,
  ProductionByMonthStackedChartComponent,
  CapexByYearStackedChartComponent,
  ReservesByCountryStackedByDevelopmentStatus,
  ReservesByCountryStackedByType,
];

const AssetReportComponents = [
  AssetNameComponent,
  AssetViewPictureComponent,
  CountryViewPictureComponent,
  AssetFeaturesTableComponent,
  AssetReservesTableComponent,
  AssetCurrentParticipationTableComponent,
  AssetTimeTableComponent,
  FinancialConsiderationsTableComponent,
  HistoricalParticipationTableComponent,
  ReservoirCharacteristicsTableComponent,
  ProductionByMonthStackedByTypeChartComponent,
  ProductionByMonthStackedByTypeTotalChartComponent,
  RemainingProjectRevenueDistributionComponent,
  WellCountByYearStackedByClassification,
  WellStatisticsTableComponent,
  KeyReservesMetricsComponent,
];

export const SmartReportComponents = [
  ...CommonReportComponents,
  ...CorporateReportComponents,
  ...AssetReportComponents,
];
